import StyleScreen from "../StyleScreen/StyleScreen";
import settingsEditor from "../SettingsEditor/settingsEditor.css";
import Button from "../AdminPanel/Custom/Button/Button.jsx";
import calendarImg from "../picture/Calendar.png";
import folderImg from "../Editor/folder.png";
import backImg from "../Editor/nazad.png";
import sortImg from "../Editor/sortiranje.png";
import detailsImg from "../Editor/povecaj.png";
import pdfImg from "../Editor/generisi_pdf.png";
import categoryImg from "../picture/Category.png";
import userImg from "../picture/User.png";
import mailImg from "../picture/Mail.png";
import homeUserImg from "../picture/HomeUser.png";
import plusMessageNoteImg from "../picture/plus-message-note-link.png";
import closeImg from "../picture/Cancel.png";
import messageImg from "../picture/Message.png";
import penImg from "../picture/Pen.png";
import plusImg from "../picture/Plus.png";
import forthyImg from "../picture/Forthy.png";
import sixthyImg from "../picture/Sixthy.png";
import houndredImg from "../picture/Houndred.png";
import twoParagraf from "../picture/TwoParagraf.png";
import redStar from "../picture/StarRed.png";
import nElement from "../picture/NElement.png";
import leftPadding from "../picture/LeftPadding.png";
import centralPadding from "../picture/centralPadding.png";
import starImg from "../picture/StarRed.png";
import blackStarImg from "../picture/blackStar.png";
import categoriesImg from "../picture/Category.png";
import imagesImg from "../picture/slika.png";
import plusMinuesImg from "../picture/PlusMinus.png";
import sendImg from "../picture/slanje.png";
import addDocument from "../picture/Plus.png";
import linkPictureImg from "../picture/LinkWWW.png";
import documentImg from "../picture/Document.png";
import attachImg from "../picture/Prilog.png";
import wwwImg from "../picture/Www.png";
import homeImg from "../picture/House.png";
import fiftyImg from "../picture/Fifty.png";
import middleImg from "../picture/middleParagrafh.png";
import forParagrafhImg from "../picture/ForParagrafh.png";
import arrowMiddleImg from "../picture/MiddleArrowParagrafh.png";
import twentyPercent from "../picture/TwentyPercent.png";
import twoArrow from "../picture/TwoArrow.png";
import zeroImg from "../picture/Zero.png";
import oneImg from "../picture/One.png";
import twoImg from "../picture/Two.png";
import threeImg from "../picture/Three.png";
import forImg from "../picture/For.png";
import onePictureMaxImg from "../picture/OnePictureMax.png";
import fiveMb from "../picture/FiveMb.png";
import tenMb from "../picture/TenMb.png";
import houndredMbImg from "../picture/HoundredMb.png";
import threeForImg from "../picture/ThreeFor.png";
import forThreeImg from "../picture/ForThree.png";
import sixNineImg from "../picture/SixNine.png";
import nineSixImg from "../picture/NineSix.png";
import XYImg from "../picture/XY.png";
import downloadFileImg from "../picture/DownloadFile.png";
import oneImageDocument from "../picture/OneImageDocument.png";
import noneVisible from "../picture/VisibleNon.png";
import documentImage from "../picture/DocumentImage.png";
import editDocumentImg from "../picture/EditDocument.png";
import uploadDocumentImg from "../picture/UploadDocument.png";
import noteDocumentImg from "../picture/NoteDocument.png";
import folderUploadImg from "../picture/folderUpload.png";
import oneDocumentMaxImg from "../picture/oneDocumentMax.png";
import fiftyMbImg from "../picture/FiftyMb.png";
import fiftyOneMbImg from "../picture/FiftyOne.png";
import dataBaseWWWImg from "../picture/DataBaseWWW.png";
import wwwCharImg from "../picture/WWWCHAR.png";
import arrowLeftImg from "../picture/arrowLeft.png";
import blueLinkImg from "../picture/BlueLink.png";
import blackLinkImg from "../picture/BlackLink.png";
import visibleImg from "../picture/Visible.png";
import pictureImg from "../picture/slika.png";
import penMessageImg from "../picture/PenMessage.png";
import whiteMailUser from "../picture/WhiteMailUser.png";
import blackMailUser from "../picture/BlackMailUser.png";
import playLeft from "../picture/play-left.png";
import playRight from "../picture/play-right.png";
import plus from "../picture/Plus.png";
import minus from "../picture/PlusMinus.png";
import text1Img from "../picture/text1.png";
import text2Img from "../picture/text2.png";

import { useEffect, useState, useRef } from "react";
import CheckBoxRound from "./CheckBoxRound";
import CheckBoxTwoRound from "./CheckBoxTwoRound";
import CheckBoxIcon from "./CheckBoxIcon";
import Checkbox from "../AdminPanel/Component/CheckBox/CheckBox";
import { compareAsc, format } from "date-fns";
import CheckBoxSquad from "./CheckBoxSquad.jsx";
import axios from "axios";
import { useGlobalContext } from "../Context/Context.js";
import SliderMain from "../Slider/SliderMain.jsx";
import Categories from "../Categories/Categories.jsx";
import FieldSettingsEditor from "./FieldSettingsEditor.jsx";
import SettingsEditorSegment4 from "./SettingsEditorSegment4.jsx";
import SettingsEditorSegment5 from "./SettingsEditorSegment5.jsx";
import SettingsEditorSegment6 from "./SettingsEditorSegment6.jsx";
import SettingsEditorSegment7 from "./SettingsEditorSegment7.jsx";
import SettingsEditorSegment8 from "./SettingsEditorSegment8.jsx";

const SettingsEditor = (
  location,
  selectedCompany,
  sideBarRef,
  location_input,
  isLandScapeProp,
) => {
  const { baseUrl, loggedUser, apiKey, chooseObject } =
    useGlobalContext();

  const [activeCategoriesScreen, setActiveCategoriesScreen] = useState();

  console.log(location)

  // Header buttons active states - ADD ALL MISSING STATES
  const [calendarActive, setCalendarActive] = useState(false);
  const [folderActive, setFolderActive] = useState(false);
  const [pdfActive, setPdfActive] = useState(false);
  const [archiveActive, setArchiveActive] = useState(false);
  const [filterActive, setFilterActive] = useState(false);
  // These buttons are always active
  const [backActive] = useState(true);  // Always active (5)
  const [sortActive] = useState(true);  // Always active (6)
  const [detailsActive] = useState(true);  // Always active (7)

  // Combination checkbox states for 2nd row - these control position swapping
  const [calendarToFolderActive, setCalendarToFolderActive] = useState(false);
  const [archiveToLocationActive, setArchiveToLocationActive] = useState(false);
  const [backToPdfActive, setBackToPdfActive] = useState(false);

  // Text input for archive label
  const [archiveText, setArchiveText] = useState("ARCHIVE");

  // 2.1
  const [filterCategoryActive, setFilterCategoryActive] = useState(false);
  const [filterUserActive, setFilterUserActive] = useState(false);
  const [filterContentActive, setFilterContentActive] = useState(false);

  const [combineCalendarAndPdf, setCombineCalendarAndPdf] = useState(false);
  const [combineArchiveAndPdf, setCombineArchiveAndPdf] = useState(false);
  const [combineFilterAndPdf, setCombineFilterAndPdf] = useState(false);
  const [pdfCategoryActive, setPdfCategoryActive] = useState(false);
  const [pdfUserActive, setPdfUserActive] = useState(false);
  const [pdfContentActive, setPdfContentActive] = useState(false);

  // Add these descriptive state variables after your existing useState declarations
  const [showTimeZone, setShowTimeZone] = useState(false);
  const [showUpdatedAt, setShowUpdatedAt] = useState(false);
  const [showNumOfComments, setShowNumOfComments] = useState(false);
  const [changeFormHeaderOrder, setChangeFormHeaderOrder] = useState(false);

  const [userNameDisplayType, setUserNameDisplayType] = useState("EMAIL");
  const [userNameAlign, setUserNameAlign] = useState("LEFT");

  const [titleLength, setTitleLength] = useState("NROWS");


  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const [data, setData] = useState(null);

  useEffect(() => {
    // 2. Define an async function to fetch data
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://data.nadzor.app/api/admin_panel/location_config/read.php?location_id=${location.location_input}`);
        // 3. Store the received data in state
        setData(response.data.data);

        setCalendarActive(response.data.data.calendar_active);
        setFolderActive(response.data.data.folder_active);
        setPdfActive(response.data.data.pdf_active);
        setArchiveActive(response.data.data.archive_active);
        setFilterActive(response.data.data.filter_active);

        setCalendarToFolderActive(response.data.data.calendar_to_folder_active);
        setArchiveToLocationActive(response.data.data.archive_to_location_active);
        setBackToPdfActive(response.data.data.back_to_pdf_active);

        setArchiveText(response.data.data.archive_text);

        setFilterCategoryActive(response.data.data.filter_category_active);
        setFilterUserActive(response.data.data.filter_user_active);
        setFilterContentActive(response.data.data.filter_content_active);

        setCombineCalendarAndPdf(response.data.data.combine_calendar_and_pdf);
        setCombineArchiveAndPdf(response.data.data.combine_archive_and_pdf);
        setCombineFilterAndPdf(response.data.data.combine_filter_and_pdf);

        setPdfCategoryActive(response.data.data.pdf_category_active);
        setPdfUserActive(response.data.data.pdf_user_active);
        setPdfContentActive(response.data.data.pdf_content_active);

        // Add these missing setters:
        setShowTimeZone(response.data.data.show_time_zone || false);
        setShowUpdatedAt(response.data.data.show_updated_at);
        setShowNumOfComments(response.data.data.show_num_of_comments);
        setChangeFormHeaderOrder(response.data.data.change_form_header_order || false);

        setUserNameDisplayType(response.data.data.user_name_display_type || "EMAIL");
        setUserNameAlign(response.data.data.user_name_align || "LEFT");
        setTitleLength(response.data.data.title_length || "NROWS");

      } catch (err) {
        // 4. Store any errors that occur
        setError(err);
      }
    };

    // Call the function
    fetchData();

    // The empty dependency array [] ensures this effect runs only once when the component mounts
  }, []);

  // Add this function after your useEffect
  const saveSettings = async (allData) => {
    try {
      const settingsData = {
        ...allData,
        location_id: location.location_input, // or use dynamic location ID
        calendar_active: calendarActive,
        folder_active: folderActive,
        pdf_active: pdfActive,
        archive_active: archiveActive,
        filter_active: filterActive,
        calendar_to_folder_active: calendarToFolderActive,
        archive_to_location_active: archiveToLocationActive,
        back_to_pdf_active: backToPdfActive,
        archive_text: archiveText,
        filter_category_active: filterCategoryActive,
        filter_user_active: filterUserActive,
        filter_content_active: filterContentActive,
        combine_calendar_and_pdf: combineCalendarAndPdf,
        combine_archive_and_pdf: combineArchiveAndPdf,
        combine_filter_and_pdf: combineFilterAndPdf,
        pdf_category_active: pdfCategoryActive,
        pdf_user_active: pdfUserActive,
        pdf_content_active: pdfContentActive,
        show_time_zone: showTimeZone,
        show_updated_at: showUpdatedAt,
        show_num_of_comments: showNumOfComments,
        change_form_header_order: changeFormHeaderOrder,
        user_name_display_type: userNameDisplayType,
        user_name_align: userNameAlign,
        title_length: titleLength
      };

      await axios.post('https://data.nadzor.app/api/admin_panel/location_config/saveSettings.php', settingsData);
    } catch (err) {
      console.error('Error saving settings:', err);
    }
  };
  const isInitialMount = useRef(true);

  const handleCheckboxChangeBoolean = async (e) => {
    const allData = {...data, [e.target.name]: e.target.checked}
    setData(allData)
    await saveSettings(allData)
  }
  const handleSetValue = async (value, name) => {
    if (value == data[name]) return

    const allData = {...data, [name]: value}
    setData(allData)
    await saveSettings(allData)
  }

  useEffect(() => {
    // This check prevents the effect from running on the initial page load
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // Set up a debounced save. This prevents a flood of API calls.
    const debouncer = setTimeout(() => {
      saveSettings(data);
    }, 500); // Waits 500ms after the last change before saving

    // Cleanup function: if another setting changes, cancel the previous timer
    return () => {
      clearTimeout(debouncer);
    };
  }, [
    // This is the dependency array. The effect runs if any of these values change.
    calendarActive,
    folderActive,
    pdfActive,
    archiveActive,
    filterActive,
    calendarToFolderActive,
    archiveToLocationActive,
    backToPdfActive,
    archiveText,
    filterCategoryActive,
    filterUserActive,
    filterContentActive,
    combineCalendarAndPdf,
    combineArchiveAndPdf,
    combineFilterAndPdf,
    pdfCategoryActive,
    pdfUserActive,
    pdfContentActive,
    showTimeZone,
    showUpdatedAt,
    showNumOfComments,
    changeFormHeaderOrder,
    userNameDisplayType,
    userNameAlign,
    titleLength
  ]);
  // Handle checkbox changes
  const handleCheckboxChange = (setter, currentValue) => {
    setter(!currentValue);
    console.log("CURRENT VALUE" + currentValue)

  };

  // Handle archive text input with uppercase and character limit
  const handleArchiveTextChange = (e) => {
    const value = e.target.value.toUpperCase().slice(0, 20);
    setArchiveText(value);

  };

  return (
    <div className="se-wrapper">
      <h3 style={{ marginBottom: "10px" }}>KONFIGURACIJA EDITORA</h3>
      <div className="se-segment1" style={{ marginBottom: "10px", display: "flex", gap: "30px" }}>
        <div className="se-segment1-left">

          <div className="se-segment1-left-header">
            <div className="ss1lh-left">
              {!calendarToFolderActive ? (
                <Button style={{ opacity: calendarActive ? 1 : 0.5 }}>
                  <img src={calendarImg} alt="" />
                  <div className="num">1</div>
                </Button>
              ) : (
                <Button style={{ opacity: folderActive ? 1 : 0.5 }}>
                  <img src={folderImg} alt="" />
                  <div className="num">3</div>
                </Button>
              )}
            </div>
            <div className="ss1lh-center">
              {!archiveToLocationActive ? (
                <>
                  <Button style={{ opacity: archiveActive ? 1 : 0.5 }}>
                    {archiveText}
                    <div className="numArchive">2</div>
                    <div className="numArchive21">2.1</div>
                  </Button>
                  <div className="locationName">
                    <p>LOKACIJA</p>
                    <div className="numLocationName">4</div>
                  </div>
                </>
              ) : (
                <>
                  <div className="locationName">
                    <p>LOKACIJA</p>
                    <div className="numLocationName">4</div>
                  </div>
                  <Button style={{ opacity: archiveActive ? 1 : 0.5 }}>
                    {archiveText}
                    <div className="numArchive">2</div>
                    <div className="numArchive21">2.1</div>
                  </Button>
                </>
              )}
            </div>
            <div className="ss1lh-right">
              {!calendarToFolderActive ? (
                <Button style={{ opacity: folderActive ? 1 : 0.5 }}>
                  <img src={folderImg} alt="" />
                  <div className="num">3</div>
                </Button>
              ) : (
                <Button style={{ opacity: calendarActive ? 1 : 0.5 }}>
                  <img src={calendarImg} alt="" />
                  <div className="num">1</div>
                </Button>
              )}
            </div>
          </div>

          <div className="report-buttons">
            {!backToPdfActive ? (
              <>
                <Button style={{ opacity: backActive ? 1 : 0.5 }}>
                  <img src={backImg} alt="" />
                  <div className="num">5</div>
                </Button>
                <Button style={{ opacity: sortActive ? 1 : 0.5 }}>
                  <img src={sortImg} alt="" />
                  <div className="num">6</div>
                </Button>
                <Button style={{ opacity: detailsActive ? 1 : 0.5 }}>
                  <img src={detailsImg} alt="" />
                  <div className="num">7</div>
                </Button>
                <Button style={{ opacity: pdfActive ? 1 : 0.5 }}>
                  <img src={pdfImg} alt="" />
                  <div className="num">8</div>
                </Button>
              </>
            ) : (
              <>
                <Button style={{ opacity: pdfActive ? 1 : 0.5 }}>
                  <img src={pdfImg} alt="" />
                  <div className="num">8</div>
                </Button>
                <Button style={{ opacity: sortActive ? 1 : 0.5 }}>
                  <img src={sortImg} alt="" />
                  <div className="num">6</div>
                </Button>
                <Button style={{ opacity: detailsActive ? 1 : 0.5 }}>
                  <img src={detailsImg} alt="" />
                  <div className="num">7</div>
                </Button>
                <Button style={{ opacity: backActive ? 1 : 0.5 }}>
                  <img src={backImg} alt="" />
                  <div className="num">5</div>
                </Button>
              </>
            )}
          </div>

          <div className="checkboxes-1st-row">
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={calendarActive}
                onChange={() => handleCheckboxChange(setCalendarActive, calendarActive)}
              />
              <div className="num-checkbox">1</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={archiveActive}
                onChange={() => handleCheckboxChange(setArchiveActive, archiveActive)}
              />
              <div className="num-checkbox">2</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={filterActive}
                onChange={() => handleCheckboxChange(setFilterActive, filterActive)}
              />
              <div className="num-checkbox">2.1</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={folderActive}
                onChange={() => handleCheckboxChange(setFolderActive, folderActive)}
              />
              <div className="num-checkbox">3</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={pdfActive}
                onChange={() => handleCheckboxChange(setPdfActive, pdfActive)}
              />
              <div className="num-checkbox">8</div>
            </div>
          </div>

          <div className="checkboxes-2nd-row">
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={calendarToFolderActive}
                onChange={() => handleCheckboxChange(setCalendarToFolderActive, calendarToFolderActive)}
              />
              <div className="num-checkbox">1</div>
              <img src={twoArrow} alt="" />
              <div className="num-checkbox">3</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={archiveToLocationActive}
                onChange={() => handleCheckboxChange(setArchiveToLocationActive, archiveToLocationActive)}
              />
              <div className="num-checkbox">2</div>
              <img src={twoArrow} alt="" />
              <div className="num-checkbox">4</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={backToPdfActive}
                onChange={() => handleCheckboxChange(setBackToPdfActive, backToPdfActive)}
              />
              <div className="num-checkbox">5</div>
              <img src={twoArrow} alt="" />
              <div className="num-checkbox">8</div>
            </div>
          </div>

          <div className="checkboxes-3rd-row">
            <div style={{ display: "flex" }}>
              <div className="num-checkbox" style={{ marginRight: "10px" }}>2</div>
              <h2>ARCHIVE</h2>
            </div>
            <input
              type="text"
              style={{ width: "60%" }}
              value={archiveText}
              onChange={handleArchiveTextChange}
              maxLength={20}
            />
          </div>
          <div className="checkboxes-3rd-row">
            <div style={{ display: "flex" }}>
              <div className="num-checkbox" style={{ marginRight: "10px" }}>2.1</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={filterCategoryActive}
                onChange={() => handleCheckboxChange(setFilterCategoryActive, filterCategoryActive)}
              />
              <img style={{ height: "20px" }} src={categoryImg} alt="" />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={filterUserActive}
                onChange={() => handleCheckboxChange(setFilterUserActive, filterUserActive)}
              />
              <img style={{ height: "20px" }} src={userImg} alt="" />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={filterContentActive}
                onChange={() => handleCheckboxChange(setFilterContentActive, filterContentActive)}
              />
              <img style={{ height: "20px" }} src={plusMessageNoteImg} alt="" />
            </div>
          </div>

          <div className="checkboxes-3rd-row">
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={combineCalendarAndPdf}
                onChange={() => handleCheckboxChange(setCombineCalendarAndPdf, combineCalendarAndPdf)}
              />
              <div className="num-checkbox">1</div>
              <img src={plusImg} alt="" />
              <div className="num-checkbox">8</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={combineArchiveAndPdf}
                onChange={() => handleCheckboxChange(setCombineArchiveAndPdf, combineArchiveAndPdf)}
              />
              <div className="num-checkbox">2</div>
              <img src={plusImg} alt="" />
              <div className="num-checkbox">8</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={combineFilterAndPdf}
                onChange={() => handleCheckboxChange(setCombineFilterAndPdf, combineFilterAndPdf)}
              />
              <div className="num-checkbox">2.1</div>
              <img src={plusImg} alt="" />
              <div className="num-checkbox">8</div>
            </div>
          </div>


          <div className="checkboxes-3rd-row">
            <div style={{ display: "flex" }}>
              <div className="num-checkbox" style={{ marginRight: "10px" }}>8</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={pdfCategoryActive}
                onChange={() => handleCheckboxChange(setPdfCategoryActive, pdfCategoryActive)}
              />
              <img style={{ height: "20px" }} src={categoryImg} alt="" />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={pdfUserActive}
                onChange={() => handleCheckboxChange(setPdfUserActive, pdfUserActive)}
              />
              <img style={{ height: "20px" }} src={userImg} alt="" />
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={pdfContentActive}
                onChange={() => handleCheckboxChange(setPdfContentActive, pdfContentActive)}
              />
              <img style={{ height: "20px" }} src={plusMessageNoteImg} alt="" />
            </div>
          </div>

        </div>

        <div className="se-segment1-right">
          <img src={text1Img} style={{width: "100%", height: "400px"}}/>
        </div>
      </div>

      <hr />

      <div style={{ display: "flex", gap: "30px" }}>
        <div className="se-segment2">
          <div className="se-segment2-1st-row">
            <div className="se-segment2-1st-row-top">
              <h4>36.</h4>
              <p style={{textAlign: userNameAlign == "CENTER" ? "center" : "left", width: "100%"}}>
                {userNameDisplayType == "EMAIL" ? "Email adresa" : userNameDisplayType == "PROFILE_NAME" ? "Ime korisnika" : "Ime korisnika u kompaniji"}
              </p>
              <p>08:45</p>
            </div>
            <div className="se-segment2-1st-row-mid">
              <h4>NASLOV NOVE STAVKE</h4>
              <p>{showUpdatedAt ? "11:10" : showNumOfComments ? <div style={{ display: "flex", alignItems: "center" }}>
                <img style={{ height: "10px", marginRight: "5px" }} src={messageImg} alt="" />
                <p>
                  1
                </p>
              </div> : ""
              }</p>
            </div>
            <div className="se-segment2-1st-row-bottom">
              {showNumOfComments && showUpdatedAt && <>
                <img style={{ height: "10px", marginRight: "5px" }} src={messageImg} alt="" />
                <p>
                  1
                </p>
              </>
              }
            </div>
          </div>

          <div className="se-segment2-2nd-row" style={{ display: "flex", flexDirection: changeFormHeaderOrder ? "column-reverse" : "column" }}>
            <div className="se-segment2-2nd-row-top"
              style={{
                borderTop: changeFormHeaderOrder ? "1px solid black" : "none",
                borderBottom: changeFormHeaderOrder ? "none" : "1px solid black"
              }}
            >
              <h4>36.</h4>
              <p style={{textAlign: userNameAlign == "CENTER" ? "center" : "left", width: "100%"}}>
                {userNameDisplayType == "EMAIL" ? "xxxxxxx@gmail.com" : userNameDisplayType == "PROFILE_NAME" ? "Ime korisnika" : "Ime korisnika u kompaniji"}
              </p>
              <p>08:41</p>
            </div>
            <div className="se-segment2-2nd-row-bottom">
              <Button>
                <img src={closeImg} alt="" />
              </Button>
            </div>
          </div>

          <div className="se-segment2-3rd-row">
            <div className="se-segment2-3rd-row-top">
              <div className="ss2-3rd-rt-small">10</div>
              <div className="ss2-3rd-rt-large">11</div>
              <div className="ss2-3rd-rt-small" style={{ border: "2px dashed black" }}>13.1</div>
              <div className="ss2-3rd-rt-small">13</div>
            </div>

            <div className="se-segment2-3rd-row-bottom">
              <div className="ss2-3rd-rt-bottom-large">
                <div className="num-checkbox-ss23r">9</div>
                12
              </div>
              <div className="ss2-3rd-rt-bottom-small">
                <div>14</div>
                <div>15</div>
              </div>
            </div>
          </div>

          <div className="se-segment2-4th-row">
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={showUpdatedAt}
                onChange={() => handleCheckboxChange(setShowUpdatedAt, showUpdatedAt)}
              />
              <div className="num-checkbox">14</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={showNumOfComments}
                onChange={() => handleCheckboxChange(setShowNumOfComments, showNumOfComments)}
              />
              <div className="num-checkbox">15</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"

              />
              <div className="num-checkbox wide" style={{ fontSize: "12px" }}>13.1</div>
            </div>
            <div className="one-checbox">
              <input
                type="checkbox"
                checked={changeFormHeaderOrder}
                onChange={() => handleCheckboxChange(setChangeFormHeaderOrder, changeFormHeaderOrder)}
              />
              <div className="num-checkbox" style={{ color: "green" }}>12</div>
              <img src={twoArrow} alt="" />
              <div className="num-checkbox">10</div>
              <div className="num-checkbox">11</div>
            </div>
          </div>

          <div className="se-segment2-5th-row">
            <div className="num-checkbox">11</div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="userNameDisplayType"
                checked={userNameDisplayType == "EMAIL"}
                onChange={() => setUserNameDisplayType("EMAIL")}
              />

              <img src={mailImg} alt="" />

            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="userNameDisplayType"
                checked={userNameDisplayType == "PROFILE_NAME"}
                onChange={() => setUserNameDisplayType("PROFILE_NAME")}
              />
              <img src={userImg} alt="" />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="userNameDisplayType"
                checked={userNameDisplayType == "COMPANY_NAME"}
                onChange={() => setUserNameDisplayType("COMPANY_NAME")}
              />
              <img src={homeUserImg} alt="" />

              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="userNameAlign"
                  checked={userNameAlign == "LEFT"}
                  onChange={() => setUserNameAlign("LEFT")}
                />
                <img src={leftPadding} alt="" />
              </div>
              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="userNameAlign"
                  checked={userNameAlign == "CENTER"}
                  onChange={() => setUserNameAlign("CENTER")}
                />
                <img src={centralPadding} alt="" />
              </div>
            </div>
          </div>
          <div className="se-segment2-5th-row">
            <div className="num-checkbox" style={{ color: "green" }}>12</div>
            <div className="one-checbox">
              <input
                type="checkbox"
                name="titleLength"
                checked={titleLength == "40"}
                onClick={() => setTitleLength("40")}
              />

              <img src={forthyImg} style={{ height: "15px" }} alt="" />

            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="titleLength"
                checked={titleLength == "60"}
                onClick={() => setTitleLength("60")}
              />
              <img src={sixthyImg} alt="" style={{ height: "15px" }} />
            </div>

            <div className="one-checbox">
              <input
                type="checkbox"
                name="titleLength"
                checked={titleLength == "100"}
                onClick={() => setTitleLength("100")}
              />
              <img src={houndredImg} alt="" style={{ height: "15px" }} />

              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="titleLength"
                  checked={titleLength == "2ROWS"}
                  onClick={() => setTitleLength("2ROWS")}
                />
                <img src={twoParagraf} alt="" />
              </div>
              <div className="one-checbox">
                <input
                  type="checkbox"
                  name="titleLength"
                  checked={titleLength == "NROWS"}
                  onClick={() => setTitleLength("NROWS")}
                />
                <img src={nElement} alt="" style={{ height: "12px" }} />
              </div>
            </div>
          </div>
        </div>
        <div>
          <img src={text2Img} style={{width: "100%", height: "400px"}}/>
        </div>
      </div>
      <hr style={{marginTop: "10px"}}/>

      <FieldSettingsEditor location_input={location.location_input} data={data}/>
      <hr style={{marginTop: "10px"}}/>

      <SettingsEditorSegment4 location={location} data={data} handleCheckboxChange={handleCheckboxChangeBoolean} handleSetValue={handleSetValue}/>
      <hr style={{marginTop: "10px"}}/>

      <SettingsEditorSegment5 data={data} handleCheckboxChange={handleCheckboxChangeBoolean} handleSetValue={handleSetValue}/>
      <SettingsEditorSegment6 data={data} handleCheckboxChange={handleCheckboxChangeBoolean} handleSetValue={handleSetValue}/>
      <SettingsEditorSegment7 data={data} handleCheckboxChange={handleCheckboxChangeBoolean} handleSetValue={handleSetValue}/>
      <hr style={{marginTop: "10px"}}/>

      <SettingsEditorSegment8 data={data} handleCheckboxChange={handleCheckboxChangeBoolean}/>
    </div>
  );
};

export default SettingsEditor;